<itl-detail-item>
  <itl-detail-item-icon>
    <itl-alberta-icon name="alberta-article"></itl-alberta-icon>
  </itl-detail-item-icon>
  <div class="articleData">
    <div>
      <div class="articleName bold">{{ articleLine?.article?.name }}</div>
      <div class="bold dosage">
        {{ articleLine?.quantity }} {{ articleLine?.unit | articleUnitPipe }} ({{ 'singleOrder.quantity' | translate }}:
        {{ articleLine?.packagingUnit?.quantity }} {{ 'article.edit.units.stk' | translate }})
      </div>
    </div>
    <div class="labels">
      <itl-label
        *ngIf="articleLine?.article?.prescriptionType == null"
        baseColor="#2B2B2B"
        [infoHeader]="'prescription.create.noPrescriptionType' | translate"
        [infoMessage]="'prescription.create.noPrescriptionType_info' | translate"
        showInfoBox="true"
        >{{ 'prescription.create.noPrescriptionType' | translate }}</itl-label
      >
      <itl-label
        *ngIf="articleLine?.isPrivateSale"
        baseColor="#2B2B2B"
        [infoHeader]="'article.details.isPrivateSale' | translate"
        [infoMessage]="'prescription.create.privateSale_info' | translate"
        showInfoBox="true"
        >{{ 'article.details.isPrivateSale' | translate }}</itl-label
      >
      <itl-label
        *ngIf="articleLine?.article?.status === ArticleStatus.NotAvailable"
        baseColor="#cf0000"
        [infoHeader]="'article.edit.status.notAvailable' | translate"
        [infoMessage]="'prescription.create.notAvailable_info' | translate"
        showInfoBox="true"
        >{{ 'article.edit.status.notAvailable' | translate }}</itl-label
      >
      <itl-label
        *ngIf="contract?.flatChargeTextAllowed && contract?.flatChargeText?.length"
        baseColor="#2B2B2B"
        [infoHeader]="'prescription.create.flatChargeText' | translate"
        [infoMessage]="contract.flatChargeText"
        showInfoBox="true"
        >{{ 'insuranceContract.pricingModelType.flatCharge' | translate }}</itl-label
      >
      <itl-card class="showMoreButton" (click)="toggleShowMore()"
        ><itl-alberta-icon [name]="articleExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></itl-alberta-icon
      ></itl-card>
    </div>
  </div>
  <div *ngIf="articleExpanded" class="cardContainer">
    <itl-card [header]="'article.details.description' | translate">
      {{ articleLine?.article?.description ? articleLine?.article?.description : 'k.A.' }}
    </itl-card>
    <itl-card [header]="'article.details.additionalDescription' | translate">
      {{ articleLine?.article?.additionalDescription ? articleLine?.article?.additionalDescription : 'k.A.' }}
    </itl-card>
    <itl-card [header]="'article.details.pcn' | translate">
      {{ articleLine?.article?.pcn ? articleLine?.article?.pcn : 'k.A.' }}
    </itl-card>
  </div>
</itl-detail-item>
